import { FeatureFlag } from '@/infra/feature-flag/feature-flag'
import { LDClient, useLDClient } from 'launchdarkly-react-client-sdk'
import { RouteObject } from 'react-router-dom'
import {
  makeFirstAccessCpfPage,
  makeFirstAccessPage
} from '../../factories/pages/static-pages-factory'
import PathConstants from '../path-contants'
import BasicLayout from '@/presentation/components/ui/layout/basic-layout'

const { FIRST_ACCESS, FIRST_ACCESS_CPF } = PathConstants.StaticRoutes

const FirstAccessRoutesBuilder = (): RouteObject[] => {
  const ldClient = useLDClient() as LDClient
  const paths = [
    {
      path: FIRST_ACCESS.value,
      element: <BasicLayout footerVariant="compact" />,
      children: [
        {
          path: FIRST_ACCESS.value,
          element: makeFirstAccessPage()
        },
        {
          path: FIRST_ACCESS_CPF.value,
          element: makeFirstAccessCpfPage()
        }
      ],
      flag: FeatureFlag.Key.FIRST_ACCESS
    }
  ].filter(route => {
    if (!route.flag) return true
    return route.flag.isEnabled(ldClient)
  })

  return paths
}
export default FirstAccessRoutesBuilder
